// The meter — what the connection costs (Josh, 09-27: "I want to see the data usage of the app") and the stream's
// frame rate. Bytes come from the peer connection's own stats every second; the day's total is kept in the
// browser so a phone on cellular can see what the app has used since midnight. The figures live in the sheet
// (⋯ › Stream), and the sheet's frame-rate buttons keep the old default rate (each window's own is in its
// Pointer menu).
//
// `startMeter({ pc, streams, connected })`: `pc()` the current peer connection or null, `streams()` the open streams,
// `connected()` whether a Mac is; `wantedFPS()` the default rate.
let wantedFPS = 30
try { wantedFPS = Number(localStorage.getItem('cody.fps')) || 30 } catch {}
export const getWantedFPS = () => wantedFPS

/// The day's bytes, kept in the browser and started again at midnight (UTC): what this connection added is added.
export function todayUsage(addReceived = 0, addSent = 0, now = new Date()) {
  const day = now.toISOString().slice(0, 10)
  let kept = { day, received: 0, sent: 0 }
  try { const k = JSON.parse(localStorage.getItem('cody.data') || 'null'); if (k && k.day === day) kept = k } catch {}
  kept.received += addReceived; kept.sent += addSent
  try { localStorage.setItem('cody.data', JSON.stringify(kept)) } catch {}
  return kept
}
const mb = (n) => (n / 1048576).toFixed(n < 10485760 ? 2 : 1) + ' MB'

/// The sheet's lines: the incoming rate (and, while streaming, the frames a second and how many streams), this
/// connection's MB in and out, and the day's.
export function usageText({ rate, fps, streams, received, sent, day }) {
  return `↓ ${rate >= 1000 ? (rate / 1000).toFixed(1) + ' Mb/s' : Math.round(rate) + ' kb/s'}${streams > 0 ? ` · ${fps} fps · ${streams} stream${streams === 1 ? '' : 's'}` : ''}\nThis connection: ${mb(received)} in, ${mb(sent)} out\nToday: ${mb(day.received)} in, ${mb(day.sent)} out`
}

export function startMeter({ pc, streams, connected }) {
  const meter = document.getElementById('meter'), usageLine = document.getElementById('usage'), streamBox = document.getElementById('stream')
  const usage = { received: 0, sent: 0, lastReceived: 0, lastSent: 0, lastFrames: 0, rate: 0, fps: 0 }
  setInterval(async () => {
    const conn = pc()
    if (!conn) { meter.hidden = true; return }
    let received = 0, sent = 0
    try { for (const s of (await conn.getStats()).values()) if (s.type === 'transport') { received = s.bytesReceived || 0; sent = s.bytesSent || 0 } } catch { return }
    const dr = Math.max(0, received - usage.lastReceived), ds = Math.max(0, sent - usage.lastSent)
    if (usage.lastReceived || usage.lastSent) { usage.received += dr; usage.sent += ds }
    usage.lastReceived = received; usage.lastSent = sent
    usage.rate = dr * 8 / 1000   // kbit/s over the last second
    const frames = window.cody?.frames || 0
    usage.fps = frames - usage.lastFrames; usage.lastFrames = frames
    const day = todayUsage(dr, ds)
    const open = streams(), streaming = open.length > 0
    // the figures live in the sheet (⋯ › Stream), not under the scene, where they took room from the window
    meter.hidden = true
    usageLine.textContent = usageText({ rate: usage.rate, fps: usage.fps, streams: streaming ? open.length : 0, received: usage.received, sent: usage.sent, day })
    streamBox.hidden = !connected()
  }, 1000)
  for (const b of document.querySelectorAll('#fps button')) {
    b.classList.toggle('on', Number(b.dataset.fps) === wantedFPS)
    b.addEventListener('click', () => {
      wantedFPS = Number(b.dataset.fps)
      try { localStorage.setItem('cody.fps', String(wantedFPS)) } catch {}
      for (const o of document.querySelectorAll('#fps button')) o.classList.toggle('on', o === b)
      // each window's own rate is in its Pointer menu now; this is only the old default
    })
  }
}
